import React from 'react'

const HomeTitle = ({ children }) => {
  return (
    <div className="home-title">
      <span>{children}</span>
    </div>
  )
}

export default HomeTitle
